// extracted by mini-css-extract-plugin
module.exports = {"list":"DocumentToolsList_list__Q_bZU","list__item":"DocumentToolsList_list__item__lfiw1"};